var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.963 1.895a.38.38 0 0 0-.261-.285 1.35 1.35 0 0 0-.708.05S1.223 7.33.322 7.957c-.194.135-.26.213-.291.306-.156.446.329.643.329.643l4.065 1.325a.45.45 0 0 0 .205-.013c.925-.584 9.304-5.874 9.788-6.052.076-.023.132 0 .12.056-.198.678-7.434 7.108-7.474 7.148a.16.16 0 0 0-.056.133l-.378 3.966s-.159 1.237 1.077 0a34 34 0 0 1 2.137-1.955c1.398.964 2.902 2.031 3.55 2.587a1.13 1.13 0 0 0 .824.318c.619-.023.788-.7.788-.7s2.873-11.562 2.97-13.112c.009-.152.022-.249.023-.353a1.3 1.3 0 0 0-.036-.359"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "telegram_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })))));
};
export default SvgTelegram;